import { object, string } from 'yup';
import i18n from '../../../i18n';

// Types
import { ExternalCompanyManagement } from './types';

export const ExternalCompanyManagementSchema = object<ExternalCompanyManagement>(
  {
    companyName: string().required(() => i18n.t('validation:required')),
  }
);
